import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { Erp1cObjectTypeEnum } from '@zaoblako/shared/modules/catalog/enums/erp-1c-object-type.enum';
import { Erp1cObjectTypeEnumI18n } from '@zaoblako/shared/modules/catalog/i18n/erp-1c-object-type-enum.i18n';

@Pipe({
  name: 'erp1cObjectTypeName',
  standalone: true
})
export class Erp1cObjectTypeNamePipe implements PipeTransform {
  public transform(type: Erp1cObjectTypeEnum): string {
    return Erp1cObjectTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
